export const defaultFormState = {
  "showForm": false,
  "showDeleteWarning": false,
  "showItemChangedWarning": false,
  "formHeader": "Edit equipment ownership type",
  "formDescription": "",
  "formDataChangedWarning": "Dane zostały zmienione",
  "formAddingDataMode": false,
  "formSaveButtonDisabled": false,
  "warningDescription":"",
  "warningDeleteButtonDisabled": false,
  "warningWarningIconVisible":false
}
